'use strict'
import * as colorsObj from './theme/colors'

/**
 * origin => target
 * @param {object} target
 */
export function extend (target) {
  if (target === null || target === undefined) target = {}
  for (let i = 1; i < arguments.length; ++i) {
    let origin = arguments[i]
    for (let key in origin) {
      if (origin.hasOwnProperty(key)) {
        let value = origin[key]
        if (value !== undefined) target[key] = value
      }
    }
  }
  return target
}

export function findIndex (ary, fn) {
  if (ary.findIndex) {
    return ary.findIndex(fn)
  }
  /* istanbul ignore next */
  let index = -1
  /* istanbul ignore next */
  ary.some(function (item, i, ary) {
    const ret = fn.call(this, item, i, ary)
    if (ret) {
      index = i
      return ret
    }
  })
  /* istanbul ignore next */
  return index
}

export function isNotNull (val) {
  return val !== undefined && val !== null
}

export function isNull (val) {
  return val === undefined || val === null
}

/**
 * 将 String, Object, Array 转成 Array
 */
export function convertClass (classes) {
  let newClasses = []
  if (!classes) return newClasses
  if (classes instanceof Array) {
    newClasses = newClasses.concat(classes)
  } else if (classes instanceof Object) {
    for (const name in classes) {
      if (classes[name]) newClasses.push(name)
    }
  } else {
    newClasses = newClasses.concat(classes.split(' '))
  }
  return newClasses
}

const colors = Object.keys(colorsObj)
export function getColor (color) {
  if (!color || ['primary', 'secondary', 'success', 'warning', 'info', 'error'].indexOf(color) !== -1) return ''
  return colors.indexOf(color) !== -1 ? colorsObj[color] : color
}

export function getComputedStyle (dom, attr) {
  return document.defaultView.getComputedStyle(dom, null)[attr]
}



// WEBPACK FOOTER //
// ./src/utils/tools.js